var company = {};
module['exports'] = company;
company.suffix = require("./suffix");
company.adjective = require("./adjective");
company.descriptor = require("./descriptor");
company.noun = require("./noun");
company.bs_verb = require("./bs_verb");
company.name = require("./name");
company.bs_adjective = require("./bs_adjective");
company.bs_noun = require("./bs_noun");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/es_MX/company/index.js
// module id = 1234
// module chunks = 0